<template>
  <form v-on:submit.prevent="save" class="preferences">
    <h3 class="title is-4">{{ $t("Behavior") }}</h3>
    <div class="field">
      <label class="checkbox">
        <input
          type="checkbox"
          v-model="editPreferences.saveShoppedItemGeolocation"
        />
        {{ $t("Save geolocation of each shopped item") }}
      </label>
    </div>
    <div class="field">
      <div class="control">
        <input type="submit" :value="$t('Save')" class="button is-primary" />
      </div>
    </div>
    <h3 class="title is-4">{{ $t("Development") }}</h3>
    <div class="field">
      <label class="checkbox">
        <input
          type="checkbox"
          v-model="editPreferences.sentryErrorTrackingOptIn"
        />
        {{ $t("sentry-reporting") }}
      </label>
    </div>
    <div class="field">
      <div class="control">
        <input type="submit" :value="$t('Save')" class="button is-primary" />
      </div>
    </div>
  </form>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "Preferences",
  data() {
    return {
      editPreferences: {},
    };
  },
  mounted() {
    this.editPreferences = { ...this.$store.state.preferences };
  },
  methods: {
    save: function () {
      const shouldReload =
        this.editPreferences.sentryErrorTrackingOptIn !==
        this.$store.state.preferences.sentryErrorTrackingOptIn;

      this.$store.commit("savePreferences", this.editPreferences);
      if (
        this.$store.state.preferences.saveShoppedItemGeolocation &&
        "geolocation" in navigator
      ) {
        // Ensure we have permissions or prompt the user right now
        navigator.permissions
          .query({ name: "geolocation" })
          .then((permission) => {
            if (permission.state !== "granted") {
              navigator.geolocation.getCurrentPosition(() => {});
            }
          });
      }

      if (shouldReload) {
        location.reload();
      }
    },
  },
});
</script>

<style scoped></style>
<i18n>
{
  "en": {
    "sentry-reporting": "Report errors via Sentry.io third party service"
  },
  "de": {
    "Behavior": "Verhalten",
    "Development": "Entwicklung",
    "CouchDB instance for saving": "CouchDB-Instanz zum Speichern",
    "Save geolocation of each shopped item": "Standort jedes Einkaufs speichern (GPS)",
    "sentry-reporting": "Fehler über den externen Dienst Sentry.io melden"
  }
}
</i18n>
